// app/javascript/controllers/reveal_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["more", "button", "preview"] // <-- preview is optional
    static values = {
        expanded: { type: Boolean, default: false },
        collapsedLabel: { type: String, default: "Explore all" },
        expandedLabel:  { type: String, default: "Show less" }
    }

    connect() {
        if (!this.expandedValue && this.hasMoreTarget) this.hide()
    }

    toggle(e) { e?.preventDefault(); this.expandedValue ? this.hide() : this.show() }

    show() {
        this.moreTarget.classList.remove("d-none")
        if (this.hasPreviewTarget) this.previewTarget.classList.add("d-none") // hide preview
        this.buttonTarget.setAttribute("aria-expanded", "true")
        this.buttonTarget.textContent = this.expandedLabelValue
        this.expandedValue = true
    }

    hide() {
        this.moreTarget.classList.add("d-none")
        if (this.hasPreviewTarget) this.previewTarget.classList.remove("d-none") // show preview
        this.buttonTarget.setAttribute("aria-expanded", "false")
        this.buttonTarget.textContent = this.collapsedLabelValue
        this.expandedValue = false
    }
}